import {WebApplicationState} from "../types";

export const getUserLocation = (state: WebApplicationState) => state.location.userLocation;
export const getLocationFormattedAddress = (state: WebApplicationState) => state.location.formattedAddress;
export const isUserGrantedLocation = (state: WebApplicationState) => state.location.userGrantedLocation;
export const getLocationOperation = (state: WebApplicationState) => state.location.operation;